// Re-export generated types with friendly names
export type {
  shifts_ShiftResponse as Shift,
  shifts_ShiftListResponse as ShiftListResponse,
  shifts_CreateShiftRequest as CreateShiftRequest,
  shifts_UpdateShiftRequest as UpdateShiftRequest,
  shifts_UpdateShiftSeriesRequest as UpdateShiftSeriesRequest,
  shifts_AssignGroupsRequest as AssignGroupsRequest,
  shifts_CheckConflictsRequest as CheckConflictsRequest,
  shifts_ConflictResponse as ConflictResponse,
  shifts_EmployeeBrief as ShiftEmployeeBrief,
  shifts_GroupBrief as ShiftGroupBrief,
  shifts_TemplateResponse as ShiftTemplate,
  shifts_TemplateListResponse as ShiftTemplateListResponse,
  shifts_CreateTemplateRequest as CreateTemplateRequest,
  shifts_UpdateTemplateRequest as UpdateTemplateRequest,
  shifts_PatternResponse as PatternResponse,
  shifts_ShiftWarningResponse as ShiftWarning,
  shifts_PublishPreviewResponse as PublishPreview,
  shifts_CreateShiftResponse as CreateShiftResponse,
  shifts_UpdateShiftSeriesResponse as UpdateShiftSeriesResponse,
  shifts_SeriesUpdateSummary as SeriesUpdateSummary,
  shifts_ShiftConflictErrorResponse as ShiftConflictErrorResponse,
} from '@/api';

// Status and Type constants
export const ShiftStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
} as const;

export type ShiftStatusType = (typeof ShiftStatus)[keyof typeof ShiftStatus];

export const ShiftType = {
  REGULAR: 'REGULAR',
  OVERTIME: 'OVERTIME',
  ON_CALL: 'ON_CALL',
} as const;

export type ShiftTypeValue = (typeof ShiftType)[keyof typeof ShiftType];

// List parameters interface
export interface ShiftListParams {
  limit?: number;
  offset?: number;
  employeeId?: string;
  groupId?: string;
  fromDate?: string; // YYYY-MM-DD
  toDate?: string; // YYYY-MM-DD
  status?: ShiftStatusType;
}

export interface ShiftTemplateListParams {
  limit?: number;
  offset?: number;
}

export type CalendarViewMode = 'day' | 'week' | 'month';
